// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalCreatePolicy_basic-panel__vGbJ6","title":"ModalCreatePolicy_title__IJddl","back":"ModalCreatePolicy_back__N4HgJ","progress":"ModalCreatePolicy_progress__DfqrX"};